import { render, staticRenderFns } from "./PatronUpdatedTier.vue?vue&type=template&id=c96610e4"
import script from "./PatronUpdatedTier.vue?vue&type=script&lang=js"
export * from "./PatronUpdatedTier.vue?vue&type=script&lang=js"
import style0 from "./PatronUpdatedTier.vue?vue&type=style&index=0&id=c96610e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports